var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('ProductAmountModeSection',{attrs:{"mode":_vm.mode},on:{"switch":_vm.switchMode}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }